<script lang="ts">
  import QuestionText1 from "./QuestionText1.svelte";
  import QuestionText2 from "./QuestionText2.svelte";
  import QuestionText3 from "./QuestionText3.svelte";
  import QuestionText4 from "./QuestionText4.svelte";

  export let word: string
  export let formNumber: Number
</script>

<div style="text-align: center;">
  {#if formNumber === 0}
    <QuestionText1 {word} />
  {:else if formNumber === 1}
    <QuestionText2 {word} />
  {:else if formNumber === 2}
    <QuestionText3 {word} />
  {:else if formNumber === 3}
    <QuestionText4 {word} />
  {/if}
</div>